interface ViewMapProps {
    latitude: number;
    longitude: number;
}

function ViewMap({ latitude, longitude }: ViewMapProps) {
    return(
        <div style={{ height: '100%', width: '100%' }}>
            <iframe
                width="100%"
                height="100%"
                src={`https://www.openstreetmap.org/export/embed.html?bbox=${longitude-0.01}%2C${latitude-0.01}%2C${longitude+0.01}%2C${latitude+0.01}&layer=mapnik&marker=${latitude}%2C${longitude}&lang=en`}
                style={{ border: 0 }}
                allowFullScreen></iframe>
        </div>
    );
}

export default ViewMap;